import styles from './style.module.scss';
import { Col, Divider, Row, Spin, Table, Typography } from 'antd';
import useKpi from '../useKpi';
import UIHelper from '../../../../../helpers/UIHelper';
import PrintFilterText from '../../printFiiterText';

const Print = ({
  allReports = false,
  allReportsData,
  isAllReports,
  isMain,
}) => {
  const {
    data,
    summary,
    summary2,
    summary3,
    title,
    loading,
    searchParams,
    filters,
  } = useKpi(true, allReportsData, isAllReports);
  if (!isMain) {
    localStorage.setItem('auth_token', searchParams.get('token'));
  }

  const searchParamsObj = Object.fromEntries([...searchParams]);
  const searchParamsObjKeys = Object.keys(searchParamsObj);
  const availableFilters = filters.filter((i) =>
    searchParamsObjKeys.includes(i.name),
  );

  return (
    <>
      <div className={styles.container}>
        <Spin spinning={loading}>
          {!allReports && (
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>{title}</Typography.Title>
              </Col>
              <PrintFilterText
                availableFilters={availableFilters}
                searchParams={searchParams}
              />
            </Row>
          )}
          {allReports && (
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>Overview KPIs</Typography.Title>
              </Col>
            </Row>
          )}
          <br />
          <Row>
            <Col span={24} className={'chartColl'}>
              <Table
                columns={UIHelper.assignTire(data.table1.columns)}
                dataSource={data.table1.data}
                summary={summary}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{}}
                loading={loading}
              />
            </Col>
            <Divider />
            <Col span={24}>
              <Table
                columns={UIHelper.assignTire(data.table2.columns)}
                dataSource={data.table2.data}
                summary={summary2}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{}}
                loading={loading}
              />
            </Col>
            <Divider />
            <Col span={24}>
              <Table
                columns={UIHelper.assignTire(data.table3.columns)}
                dataSource={data.table3.data}
                summary={summary3}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                loading={loading}
              />
            </Col>
          </Row>
        </Spin>
      </div>
    </>
  );
};

export default Print;
